export enum TankEventEnum {
    None =  0,
    TankStyleChanged = 1,
    RemovedFromBattery = 2,
    AddedToBattery = 3
}
